/* ============================================================
   MatrixRGB — Global Theme State Engine
   Vanilla ES6 | Zero dependencies | Fully reactive
   ============================================================ */

const MatrixRGB = (() => {
  'use strict';

  /* ── Pricing data ─────────────────────────────────────────── */
  const TIERS = {
    1: { id: 57792098697548, name: 'Essential Glow Up',    desc: '2 Lights + Kit', price: 16.95, compare: 24.95, image: 'https://cdn.shopify.com/s/files/1/1061/4652/9612/files/image_2026-06-22_123112539.png?v=1782124278' },
    2: { id: 57792098730316, name: 'Full Vibe Kit',         desc: '4 Lights + Kit', price: 24.95, compare: 39.95, image: 'https://cdn.shopify.com/s/files/1/1061/4652/9612/files/image_2026-06-22_122419345.png?v=1782123864' },
    3: { id: 57792098763084, name: 'Ultimate Night Set Up', desc: '6 Lights + Kit', price: 32.95, compare: 49.95, image: 'https://cdn.shopify.com/s/files/1/1061/4652/9612/files/image_2026-06-22_123214177.png?v=1782124340' },
  };
  const GIFTS = {
    remote:  { name: 'FREE Remote Control',   price: 0, compare: 7.99, image: 'https://cdn.shopify.com/s/files/1/1061/4652/9612/files/image_2026-06-14_125548830.png?v=1781434552' },
    install: { name: 'FREE Installation Kit', price: 0, compare: 4.99, image: 'https://cdn.shopify.com/s/files/1/1061/4652/9612/files/image_2026-06-14_125508034.png?v=1781434511' },
  };
  const SHIPPING_PROTECTION_PRICE = 2.95;

  /* ── Reactive state ───────────────────────────────────────── */
  const state = {
    selectedTier: 2,
    giftRemoteToggle: true,
    giftInstallToggle: true,
    shippingProtectionToggle: false,
    cartOpen: false,
    cartHasItem: false,
    quantity: 1,

    countdownSeconds: (2 * 86400) + (23 * 3600) + (56 * 60) + 52,
    reservationSeconds: 289,
    _countdownInterval: null,
    _reservationInterval: null,
  };

  /* ── DOM helpers ──────────────────────────────────────────── */
  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ── Number formatting ────────────────────────────────────── */
  function fmt(n) {
    return '€' + n.toFixed(2).replace('.', ',');
  }
  function pad2(n) { return String(n).padStart(2, '0'); }

  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  /* ─────────────────────────────────────────────────────────── */
  /* TIER SELECTION                                              */
  /* ─────────────────────────────────────────────────────────── */
  function selectTier(id) {
    state.selectedTier = id;
    $$('.tier-card').forEach(c => c.classList.toggle('selected', +c.dataset.tier === id));
    refreshPriceDisplay();
    if (state.cartOpen) refreshCartItems();
  }

  /* ─────────────────────────────────────────────────────────── */
  /* TOGGLE HANDLERS                                             */
  /* ─────────────────────────────────────────────────────────── */
  function toggleGiftRemote(on)   { state.giftRemoteToggle = on;   if (state.cartOpen) refreshCartItems(); }
  function toggleGiftInstall(on)  { state.giftInstallToggle = on;  if (state.cartOpen) refreshCartItems(); }
  function toggleShipping(on)     { state.shippingProtectionToggle = on; refreshCartTotal(); }

  function increaseQty() {
    state.quantity = Math.min(state.quantity + 1, 10);
    const el = $('#qty-display');
    if (el) el.textContent = state.quantity;
    updateQtyLabel();
  }

  function decreaseQty() {
    state.quantity = Math.max(state.quantity - 1, 1);
    const el = $('#qty-display');
    if (el) el.textContent = state.quantity;
    updateQtyLabel();
  }

  function updateQtyLabel() {
    const label = $('#qty-total-label');
    const t = TIERS[state.selectedTier];
    if (label && state.quantity > 1) {
      label.textContent = '= ' + fmt(t.price * state.quantity) + ' total';
    } else if (label) {
      label.textContent = '';
    }
  }

  /* ─────────────────────────────────────────────────────────── */
  /* PRICE DISPLAY                                               */
  /* ─────────────────────────────────────────────────────────── */
  function refreshPriceDisplay() {
    const t = TIERS[state.selectedTier];
    const savings  = t.compare - t.price;
    const savePct  = Math.round((savings / t.compare) * 100);

    const setTxt = (sel, val) => { const el = $(sel); if (el) el.textContent = val; };
    setTxt('#pdp-price-current',  fmt(t.price));
    setTxt('#pdp-price-compare',  fmt(t.compare));
    setTxt('#pdp-savings-text',   'You save ' + fmt(savings));
    setTxt('#pdp-savings-badge',  'SAVE ' + savePct + '%');
  }

  /* ─────────────────────────────────────────────────────────── */
  /* COUNTDOWN TIMER (announcement bar)                         */
  /* ─────────────────────────────────────────────────────────── */
  function initCountdown() {
    const tick = () => {
      if (state.countdownSeconds <= 0) return;
      const s = state.countdownSeconds;
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sc = s % 60;

      const setEl = (id, v) => { const el = $(id); if (el) el.textContent = pad2(v); };
      setEl('#cd-days', d);
      setEl('#cd-hours', h);
      setEl('#cd-mins', m);
      setEl('#cd-secs', sc);

      state.countdownSeconds--;
    };
    tick();
    state._countdownInterval = setInterval(tick, 1000);
  }

  /* ─────────────────────────────────────────────────────────── */
  /* CART DRAWER                                                 */
  /* ─────────────────────────────────────────────────────────── */
  function openCart() {
    state.cartOpen = true;
    const drawer  = $('#cart-drawer');
    const overlay = $('#cart-overlay');
    if (drawer)  drawer.classList.add('open');
    if (overlay) {
      overlay.classList.remove('hidden');
      requestAnimationFrame(() => overlay.classList.add('opacity-100'));
    }
    document.body.style.overflow = 'hidden';
    startReservationTimer();
    refreshCartItems();
  }

  function closeCart() {
    state.cartOpen = false;
    const drawer  = $('#cart-drawer');
    const overlay = $('#cart-overlay');
    if (drawer)  drawer.classList.remove('open');
    if (overlay) {
      overlay.classList.remove('opacity-100');
      setTimeout(() => overlay.classList.add('hidden'), 360);
    }
    document.body.style.overflow = '';
    clearInterval(state._reservationInterval);
  }

  function startReservationTimer() {
    clearInterval(state._reservationInterval);
    state.reservationSeconds = 289;
    const timerEl = $('#cart-timer-display');
    const barEl   = $('#cart-reservation-bar');
    const TOTAL   = 289;

    const tick = () => {
      if (state.reservationSeconds <= 0) { state.reservationSeconds = TOTAL; }
      const m = Math.floor(state.reservationSeconds / 60);
      const s = state.reservationSeconds % 60;
      if (timerEl) timerEl.textContent = pad2(m) + ':' + pad2(s);
      if (barEl)   barEl.style.width = ((state.reservationSeconds / TOTAL) * 100) + '%';
      state.reservationSeconds--;
    };
    tick();
    state._reservationInterval = setInterval(tick, 1000);
  }

  /* ─────────────────────────────────────────────────────────── */
  /* CART ITEM RENDERING                                         */
  /* ─────────────────────────────────────────────────────────── */
  function refreshCartItems() {
    const container = $('#cart-items-container');
    if (!container) return;

    if (!state.cartHasItem) {
      container.innerHTML = `
        <div class="flex flex-col items-center justify-center h-32 gap-3 text-center">
          <p class="text-[12px] text-gray-700">Your cart is empty</p>
        </div>`;
      refreshCartTotal();
      return;
    }

    const t = TIERS[state.selectedTier];
    let html = '';

    // Main tier product
    html += `
      <div class="flex items-start gap-3 py-4 border-b border-[#1E1E22]">
        <div class="w-[64px] h-[64px] rounded-xl bg-[#161618] border border-[#1E1E22] flex items-center justify-center flex-shrink-0 overflow-hidden">
          <img src="${t.image}" style="width:100%;height:100%;object-fit:cover;border-radius:12px;" alt="">
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-[13px] font-700 text-white leading-tight">MatrixRGB ${t.name}</p>
          <button onclick="MatrixRGB.removeFromCart()" class="text-[11px] text-gray-500 hover:text-red-400 transition-colors mt-0.5">Remove</button>
          <p class="text-[11px] text-gray-500 mt-0.5">${t.desc}</p>
          <div class="flex items-center gap-2 mt-1.5">
            <span class="text-[13px] font-bold">${fmt(t.price)}</span>
            <span class="text-[11px] text-gray-600 line-through">${fmt(t.compare)}</span>
          </div>
        </div>
        <div class="flex flex-col items-end gap-2">
          <span class="text-[13px] font-bold whitespace-nowrap">${fmt(t.price * state.quantity)}</span>
          <div class="flex items-center rounded-lg overflow-hidden border border-[#2a2a2f] bg-[#0d0d0f]">
            <button onclick="MatrixRGB.cartDecreaseQty()" class="w-7 h-7 flex items-center justify-center text-white text-base font-black hover:bg-[#1E1E22] transition-colors">−</button>
            <span id="cart-qty-display" class="w-6 text-center text-[12px] font-black text-white">${state.quantity}</span>
            <button onclick="MatrixRGB.cartIncreaseQty()" class="w-7 h-7 flex items-center justify-center text-white text-base font-black hover:bg-[#1E1E22] transition-colors">+</button>
          </div>
        </div>
      </div>`;

    // Free gift items
    if (state.giftRemoteToggle) {
html += giftLineHTML('FREE Remote Control', GIFTS.remote.compare, GIFTS.remote.image);    }
    if (state.giftInstallToggle) {
html += giftLineHTML('FREE Installation Kit', GIFTS.install.compare, GIFTS.install.image);    }

    container.innerHTML = html;
    refreshCartTotal();
  }

  function giftLineHTML(name, comparePrice, image) {
    return `
      <div class="gift-line">
        <div class="w-10 h-10 rounded-lg bg-[#0d0d0f] border border-[rgba(0,212,255,0.2)] flex items-center justify-center flex-shrink-0 overflow-hidden">
<img src="${image}" style="width:100%;height:100%;object-fit:cover;" alt="${name}">        </div>
        <div class="flex-1 min-w-0">
          <p class="text-[12px] font-semibold text-white leading-tight">${name}</p>
          <p class="text-[10px] text-gray-500 mt-0.5">Retail value: ${fmt(comparePrice)}</p>
        </div>
        <span class="text-[12px] font-bold text-[#00D4FF] whitespace-nowrap">€0,00</span>
      </div>`;
  }

  function refreshCartTotal() {
    const t        = TIERS[state.selectedTier];
    const subtotal = (t.price * state.quantity) + (state.shippingProtectionToggle ? SHIPPING_PROTECTION_PRICE : 0);
    const savings  = t.compare - t.price;

    const setTxt = (id, v) => { const el = $(id); if (el) el.textContent = v; };
    setTxt('#cart-subtotal',       fmt(subtotal));
    setTxt('#cart-savings-amount', fmt(savings));
    setTxt('#cart-compare-total',  fmt(t.compare));
  }

  /* ─────────────────────────────────────────────────────────── */
  /* ADD TO CART / BUY NOW                                       */
  /* ─────────────────────────────────────────────────────────── */
  async function addToCart(buyNow = false) {
    const btnId = buyNow ? '#btn-buy-now' : '#btn-add-to-cart';
    const btn   = $(btnId);
    if (!btn || btn.disabled) return;

    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = `<span class="spinner mr-2"></span>Adding…`;

    try {
await fetch('/cart/clear.js', { method: 'POST' });
      await MatrixCart.performAddToCart(TIERS[state.selectedTier].id, state.quantity);
      state.cartHasItem = true;

      if (buyNow) {
        window.location.href = MatrixCart.buildCheckoutURL();
      } else {
        btn.innerHTML = `<span class="spinner mr-2"></span>Added!`;
        await sleep(400);
        btn.disabled = false;
        btn.innerHTML = originalHTML;
        openCart();
      }
    } catch (err) {
      console.error('[MatrixRGB] Cart error:', err);
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    }
  }

  /* ─────────────────────────────────────────────────────────── */
  /* REMOVE FROM CART                                            */
  /* ─────────────────────────────────────────────────────────── */
  async function removeFromCart() {
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      state.quantity = 1;
      state.cartHasItem = false;
      const container = $('#cart-items-container');
      if (container) container.innerHTML = `
        <div class="flex flex-col items-center justify-center h-32 gap-3 text-center">
          <p class="text-[12px] text-gray-700">Your cart is empty</p>
        </div>`;
      refreshCartTotal();
    } catch (err) {
      console.error('[MatrixRGB] Remove error:', err);
    }
  }

  /* ─────────────────────────────────────────────────────────── */
  /* DISCOUNT CODE                                               */
  /* ─────────────────────────────────────────────────────────── */
  async function applyDiscount() {
    const input = $('#discount-input');
    const btn   = $('#discount-apply-btn');
    const msg   = $('#discount-msg');
    if (!input || !input.value.trim()) return;

    if (btn) { btn.textContent = '…'; btn.disabled = true; }
    await sleep(900);
    if (btn) { btn.textContent = 'Apply'; btn.disabled = false; }
    if (msg) {
      msg.textContent = 'Code accepted — savings applied at checkout!';
      msg.className   = 'text-[11px] text-[#00D4FF] mt-1';
    }
    window._matrixDiscountCode = input.value.trim();
  }

  /* ─────────────────────────────────────────────────────────── */
  /* FAQ ACCORDION                                               */
  /* ─────────────────────────────────────────────────────────── */
  function initFAQ() {
    $$('.faq-item').forEach(item => {
      const btn = $('.faq-btn', item);
      if (!btn) return;
      btn.addEventListener('click', () => {
        const wasOpen = item.classList.contains('open');
        $$('.faq-item').forEach(i => i.classList.remove('open'));
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  /* ─────────────────────────────────────────────────────────── */
  /* PRODUCT GALLERY                                             */
  /* ─────────────────────────────────────────────────────────── */
  function initGallery() {
    const main = $('#main-product-img');
    if (!main) return;
    $$('.thumb-img').forEach(thumb => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.src || thumb.src;
        $$('.thumb-img').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* ─────────────────────────────────────────────────────────── */
  /* HEADER SCROLL BEHAVIOR                                      */
  /* ─────────────────────────────────────────────────────────── */
  function initHeaderScroll() {
    const header = $('#site-header');
    window.addEventListener('scroll', () => {
      if (!header) return;
      header.classList.toggle('scrolled', window.scrollY > 12);
    }, { passive: true });
  }

  /* ─────────────────────────────────────────────────────────── */
  /* MOBILE MENU                                                 */
  /* ─────────────────────────────────────────────────────────── */
  function toggleMobileMenu() {
    const menu = $('#mobile-menu');
    const icon = $('#mobile-hamburger-path');
    if (!menu) return;
    const open = menu.classList.toggle('open');
    menu.style.pointerEvents = open ? 'auto' : 'none';
    if (icon) {
      icon.setAttribute('d', open
        ? 'M6 18L18 6M6 6l12 12'
        : 'M4 6h16M4 12h16M4 18h16');
    }
  }

  /* ─────────────────────────────────────────────────────────── */
  /* REVEAL ON SCROLL                                            */
  /* ─────────────────────────────────────────────────────────── */
  function initReveal() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    $$('[data-reveal]').forEach(el => { el.classList.add('reveal'); obs.observe(el); });
  }

  /* ─────────────────────────────────────────────────────────── */
  /* INIT                                                        */
  /* ─────────────────────────────────────────────────────────── */
  function init() {
    initCountdown();
    initFAQ();
    initGallery();
    initHeaderScroll();
    initReveal();

    /* Tier cards */
    $$('.tier-card').forEach(c =>
      c.addEventListener('click', () => selectTier(+c.dataset.tier))
    );

    /* Gift toggles */
    const remoteEl   = $('#toggle-remote');
    const installEl  = $('#toggle-install');
    const shippingEl = $('#toggle-shipping');
    if (remoteEl)   remoteEl.addEventListener('change',  e => toggleGiftRemote(e.target.checked));
    if (installEl)  installEl.addEventListener('change', e => toggleGiftInstall(e.target.checked));
    if (shippingEl) shippingEl.addEventListener('change',e => toggleShipping(e.target.checked));

    /* Cart */
    const addBtn      = $('#btn-add-to-cart');
    const buyBtn      = $('#btn-buy-now');
    const closeBtn    = $('#cart-close-btn');
    const overlay     = $('#cart-overlay');
    const cartIconBtn = $('#header-cart-btn');
    const discountBtn = $('#discount-apply-btn');
    const mobileBtn   = $('#mobile-menu-btn');

    if (addBtn)      addBtn.addEventListener('click',      () => addToCart(false));
    if (buyBtn)      buyBtn.addEventListener('click',      () => addToCart(true));
    if (closeBtn)    closeBtn.addEventListener('click',    closeCart);
    if (overlay)     overlay.addEventListener('click',     closeCart);
    if (cartIconBtn) cartIconBtn.addEventListener('click', openCart);
    if (discountBtn) discountBtn.addEventListener('click', applyDiscount);
    if (mobileBtn)   mobileBtn.addEventListener('click',   toggleMobileMenu);

    /* Keyboard close cart */
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && state.cartOpen) closeCart();
    });

    /* Initialise default state */
    selectTier(2);
    refreshPriceDisplay();

    // Sync met echte Shopify cart
    fetch('/cart.js').then(r => r.json()).then(cart => {
      if (cart.items && cart.items.length > 0) {
        state.cartHasItem = true;
        const cartItem = cart.items[0];
        const tierEntry = Object.entries(TIERS).find(([, t]) => t.id === cartItem.variant_id);
        if (tierEntry) {
          state.selectedTier = +tierEntry[0];
          state.quantity = cartItem.quantity;
          selectTier(state.selectedTier);
        }
      }
    });
  }

  /* ─────────────────────────────────────────────────────────── */
  /* PUBLIC API                                                  */
  /* ─────────────────────────────────────────────────────────── */
  return {
    init, openCart, closeCart,
    selectTier, toggleGiftRemote, toggleGiftInstall, toggleShipping,
    increaseQty, decreaseQty,
cartIncreaseQty: async () => { state.quantity = Math.min(state.quantity + 1, 10); refreshCartItems(); const el = $('#qty-display'); if(el) el.textContent = state.quantity; updateQtyLabel(); const cart = await fetch('/cart.js').then(r => r.json()); const item = cart.items[0]; if (item) await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: item.key, quantity: state.quantity }) }); },
    cartDecreaseQty: async () => { state.quantity = Math.max(state.quantity - 1, 1); refreshCartItems(); const el = $('#qty-display'); if(el) el.textContent = state.quantity; updateQtyLabel(); const cart = await fetch('/cart.js').then(r => r.json()); const item = cart.items[0]; if (item) await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: item.key, quantity: state.quantity }) }); },
    addToCart, applyDiscount, removeFromCart, state,
  };
})();

document.addEventListener('DOMContentLoaded', MatrixRGB.init);